<template>
  <div class="table-action-wrapper">
    <Select :options="userRoleOptions" placeholder="Role" :value="query.user_role.value" @changeValue="changeUserRole"></Select>

    <Select v-if="userParent" source="user/search" type="auto" field="user.user_read_in_team" placeholder="User Parent" :value="query.parent_id.value" @changeValue="changeUserParent"></Select>
  </div>
</template>
<script>
export default {
  data() {
    return {
      query: {
        user_role: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Role'
        },
        parent_id: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Parent'
        }
      }
    }
  },
  created() {
    this.query = Object.assign(this.query, this.config?.query)
  },
  computed: {
    extraAttributes() {
      return this.config?.extraAttributes || {}
    },
    userRoleOptions() {
      return this.extraAttributes?.user_role
    },
    userParent() {
      return this.extraAttributes?.parent_id
    }
  },
  methods: {
    changeUserRole(value, e) {
      this.query.user_role = Object.assign(this.query.user_role, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeUserParent(value, e) {
      this.query.parent_id = Object.assign(this.query.parent_id, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    }
  },
  props: {
    config: Object
  }
}
</script>
